import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityList, getActivityDetail, createActivity, updateActivity, deleteActivity, auditActivity, updateActivityStatus } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getTicketRuleDetail } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { getBairunUserGroupInfoAllListByLevel } from '@/api/bairun/userGroup'; //  此处请自行替换地址

import { getSvcGroupList } from '@/api/bairun/svcGroup';
import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'PaySendTicketActivity',
  components: {},
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityList,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      discountLevel: 1,
      activityType: 100003,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      viewDialogVisible: false,
      auditDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      stationOptions: [],
      stationIdChecked: [],
      stationCheckAll: false,
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      userGroupOptions: [],
      userGroupCheckAll: false,
      userGroupChecked: [],
      svcGroupOptions: [],
      svcGroupCheckAll: false,
      svcGroupChecked: [],
      payChannelOptions: [],
      payChannelCheckAll: false,
      payChannelChecked: [],
      formData: {},
      publicRules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo', 'token'])), {}, {
    getRule: function getRule() {
      return this.publicRules;
    }
  }),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, userGroupOptions, svcGroupOptions, payChannelOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('paysuccessActivity init');
                _context3.next = 3;
                return _this3.getDict('oilCode');

              case 3:
                _this3.oilCodesOptions = _context3.sent;
                _context3.next = 6;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 6:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _this3.formData = _this3.initData();
                _this3.searchInfo.discountLevel = _this3.discountLevel;
                _this3.searchInfo.activityType = _this3.activityType;
                _context3.next = 13;
                return getBairunUserGroupInfoAllListByLevel({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 13:
                userGroupOptions = _context3.sent;
                _this3.userGroupOptions = userGroupOptions.data.list;
                _context3.next = 17;
                return getSvcGroupList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 17:
                svcGroupOptions = _context3.sent;
                _this3.svcGroupOptions = svcGroupOptions.data.list;
                _context3.next = 21;
                return getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 21:
                payChannelOptions = _context3.sent;
                _this3.payChannelOptions = payChannelOptions.data.list.filter(function (item) {
                  if (item.payChannel >= 1000 && item.payChannel < 2000) {
                    return [0, 1].includes(item.supportType);
                  }
                });

                _this3.getTableData();

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        activityNo: '',
        activityPaysuccessNo: '',
        activityName: '',
        activityStatus: 2,
        dateStart: '',
        dateEnd: '',
        giveTicketList: [this.initItemSingle()],
        shareTitle: '',
        shareAppLogo: '',
        shareTimeLineLogo: '',
        auditStatus: 2,
        auditRemark: '',
        limitMoneyType: 1,
        isRepeat: 0,
        perdayLimit: 1
      };
      return formdata;
    },
    initItemSingle: function initItemSingle() {
      return {
        limitMoney: 0,
        tickets: [this.initTicketSingle()]
      };
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        num: 1
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 添加规则
    onAddItem: function onAddItem(index) {
      var that = this;
      that.formData.giveTicketList.splice(index + 1, 0, that.initItemSingle());
    },
    // 删除规则
    onDeleteItem: function onDeleteItem(index) {
      debugger;
      var that = this;

      if (that.formData.giveTicketList.length == 1) {
        return;
      }

      that.formData.giveTicketList.splice(index, 1);
    },
    // 添加券
    onAddTicket: function onAddTicket(index, tkIndex) {
      var that = this;
      that.formData.giveTicketList[index].tickets.splice(tkIndex + 1, 0, that.initTicketSingle());
      this.$forceUpdate();
    },
    // 删除券
    onDeleteTicket: function onDeleteTicket(index, tkIndex) {
      debugger;
      var that = this;

      if (that.formData.giveTicketList[index].tickets.length == 1) {
        return;
      }

      that.formData.giveTicketList[index].tickets.splice(tkIndex, 1);
      this.$forceUpdate();
    },
    // 获取券详情
    getTicketDetail: function getTicketDetail(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(item.ticketRuleNo.trim() != '')) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(item.ticketRuleNo)
                });

              case 3:
                res = _context4.sent;

                if (res.code == 0) {
                  item.ticketRuleNo = res.data.ticketRuleNo + '';
                } else {
                  item.ticketRuleNo = '';
                }

              case 5:
                _this4.$forceUpdate();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增支付完成送券活动';
      this.formData.ruleType = 3;
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      var that = this;
      this.type = 'view';
      this.dialogTitle = '查看支付完成送券活动';
      this.viewDialogVisible = true;
      this.handleViewOrUpdate(row);
    },
    // 修改
    onUpdate: function onUpdate(row) {
      var that = this;
      that.type = 'update';
      that.addDialogVisible = true;
      that.dialogTitle = '变更支付完成送券活动';
      that.handleViewOrUpdate(row);
      that.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      getActivityDetail({
        'activityNo': row.activityNo
      }).then(function (res) {
        debugger;
        that.formData.activityNo = res.data.activityMain.activityNo;
        that.formData.activityPaysuccessNo = res.data.activitySubPaysuccess.activityPaysuccessNo;
        that.formData.activityName = res.data.activityMain.activityName;
        that.formData.activityStatus = res.data.activityMain.activityStatus;
        that.formData.dateStart = that.$options.filters.formatDate(res.data.activityMain.dateStart);
        that.formData.dateEnd = that.$options.filters.formatDate(res.data.activityMain.dateEnd);
        that.formData.auditStatus = res.data.activityMain.auditStatus;
        that.formData.auditRemark = res.data.activityMain.auditRemark;
        that.formData.isRepeat = res.data.activityMain.activityMainRule.isRepeat;
        that.formData.perdayLimit = res.data.activityMain.activityMainRule.perdayLimit;
        that.formData.giveTicketList = [];
        res.data.activitySubPaysuccessTicket.forEach(function (item) {
          var ticketItem = that.initItemSingle();
          ticketItem.limitMoney = item.limitMoney;
          ticketItem.tickets = JSON.parse(item.paysuccessTicket);
          that.formData.giveTicketList.push(ticketItem);
        });
        res.data.activityMain.activityMainSellerList.forEach(function (item) {
          that.stationIdChecked.push(item.sellerId);
        });
        that.stationCheckAll = that.stationIdChecked.length == that.stationOptions.length;
        res.data.activityMain.activityGoodsList.forEach(function (item) {
          that.oilCodesChecked.push(parseInt(item.goodsSpu));
        });
        that.oilCodesCheckAll = that.oilCodesChecked.length == that.oilCodesOptions.length;
        res.data.activityMain.activityPayChannelList.forEach(function (item) {
          that.payChannelChecked.push(parseInt(item.payChannel));
        });
        that.payChannelCheckAll = that.payChannelChecked.length == that.payChannelOptions.length; // res.data.activityMain.activitySvcGroupList.forEach(item => {
        //   that.svcGroupChecked.push(parseInt(item.svcGroupId))
        // })

        that.svcGroupCheckAll = that.svcGroupChecked.length == that.svcGroupOptions.length;
        res.data.activityMain.activityUserGroupList.forEach(function (item) {
          that.userGroupChecked.push(parseInt(item.userGroupId));
        });
        that.userGroupCheckAll = that.userGroupChecked.length == that.userGroupOptions.length; //不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.dateStart)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.dateEnd)

        that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
      }, function (error) {});
    },
    // 审核
    onAudit: function onAudit(row) {
      this.type = 'audit';
      this.auditDialogVisible = true;
      this.dialogTitle = '审核操作';
      this.formData.activityNo = row.activityNo;
    },
    handleAudit: function handleAudit() {
      var that = this;
      auditActivity({
        'activityNo': this.formData.activityNo,
        'auditStatus': this.formData.auditStatus,
        'auditRemark': this.formData.auditRemark
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 启用
    onAble: function onAble(row) {
      var that = this;
      debugger;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 禁用
    onDisable: function onDisable(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteActivity({
          'activityNo': row.activityNo
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    //油品全选
    handleOilCheckAllChange: function handleOilCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;
    },
    //油品勾选
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleOilCheckAllChange(true);
      }
    },
    //油站全选
    handleStationCheckAllChange: function handleStationCheckAllChange(val) {
      this.stationIdChecked = val ? this.stationOptions.map(function (item) {
        return item.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.stationOptions.length;
    },
    //油站勾选
    handleCheckedStationChange: function handleCheckedStationChange(value) {
      this.stationCheckAll = value.length === this.stationOptions.length;

      if (this.stationCheckAll) {
        this.handleStationCheckAllChange(true);
      }
    },
    //支付方式全选
    handlePayChannelCheckAllChange: function handlePayChannelCheckAllChange(val) {
      this.payChannelChecked = val ? this.payChannelOptions.map(function (item) {
        return item.payChannel;
      }) : [];
      this.payChannelCheckAll = this.payChannelChecked.length === this.payChannelOptions.length;

      if (this.payChannelChecked.indexOf(1002) == -1) {
        this.svcGroupCheckAll = false;
        this.svcGroupChecked = [];
      }

      if (this.payChannelChecked.filter(function (item) {
        return item != 1002;
      }).length == 0) {
        this.userGroupCheckAll = false;
        this.userGroupChecked = [];
      }
    },
    //支付方式勾选
    handleCheckedPayChannelChange: function handleCheckedPayChannelChange(value) {
      this.payChannelCheckAll = value.length === this.payChannelOptions.length;

      if (this.payChannelCheckAll) {
        this.handlePayChannelCheckAllChange(true);
      }

      if (this.payChannelChecked.indexOf(1002) == -1) {
        this.svcGroupCheckAll = false;
        this.svcGroupChecked = [];
      }

      if (this.payChannelChecked.filter(function (item) {
        return item != 1002;
      }).length == 0) {
        this.userGroupCheckAll = false;
        this.userGroupChecked = [];
      }
    },
    //会员群全选
    handleUserGroupCheckAllChange: function handleUserGroupCheckAllChange(val) {
      this.userGroupChecked = val ? this.userGroupOptions.map(function (item) {
        return item.ID;
      }) : [];
      this.userGroupCheckAll = this.userGroupChecked.length === this.userGroupOptions.length;
    },
    //会员群勾选
    handleCheckedUserGroupChange: function handleCheckedUserGroupChange(value) {
      this.userGroupCheckAll = value.length === this.userGroupOptions.length;

      if (this.userGroupCheckAll) {
        this.handleUserGroupCheckAllChange(true);
      }
    },
    //大客户群全选
    handleSvcGroupCheckAllChange: function handleSvcGroupCheckAllChange(val) {
      this.svcGroupChecked = val ? this.svcGroupOptions.map(function (item) {
        return item.groupId;
      }) : [];
      this.svcGroupCheckAll = this.svcGroupChecked.length === this.svcGroupOptions.length;
    },
    //大客户群勾选
    handleCheckedSvcGroupChange: function handleCheckedSvcGroupChange(value) {
      this.svcGroupCheckAll = value.length === this.svcGroupOptions.length;

      if (this.svcGroupCheckAll) {
        this.handleSvcGroupCheckAllChange(true);
      }
    },
    // 上传分享好友图标
    checkShareAppFile: function checkShareAppFile(file) {
      var _this5 = this;

      debugger;
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 500;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500k!');
        this.fullscreenLoading = false;
      }

      var isSize = new Promise(function (resolve, reject) {
        var width = 500;
        var height = 400;

        var _URL = window.URL || window.webkitURL;

        var img = new Image();

        img.onload = function () {
          var valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };

        img.src = _URL.createObjectURL(file);
      }).then(function () {
        return file;
      }, function () {
        _this5.$message.error('图片像素必须为500*400!');

        return Promise.reject();
      });
      return (isPng || isJPG) && isLt2M && isSize;
    },
    // 上传分享好友图标
    uploadShareAppSuccess: function uploadShareAppSuccess(res) {
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      debugger;

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        this.formData.shareAppLogo = this.path + '/' + res.data.file.url;
      } else {
        this.formData.shareAppLogo = res.data.file.url;
      }
    },
    // 上传分享朋友圈图标
    checkShareTimeLineFile: function checkShareTimeLineFile(file) {
      var _this6 = this;

      debugger;
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 < 500;

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500k!');
        this.fullscreenLoading = false;
      }

      var isSize = new Promise(function (resolve, reject) {
        var width = 200;
        var height = 200;

        var _URL = window.URL || window.webkitURL;

        var img = new Image();

        img.onload = function () {
          var valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };

        img.src = _URL.createObjectURL(file);
      }).then(function () {
        return file;
      }, function () {
        _this6.$message.error('图片像素必须为200*200!');

        return Promise.reject();
      });
      return (isPng || isJPG) && isLt2M && isSize;
    },
    // 上传分享朋友圈图标
    uploadShareTimeLineSuccess: function uploadShareTimeLineSuccess(res) {
      this.fullscreenLoading = false;

      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        this.formData.shareTimeLineLogo = this.path + '/' + res.data.file.url;
      } else {
        this.formData.shareTimeLineLogo = res.data.file.url;
      }
    },
    // 图片上传失败
    uploadError: function uploadError() {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.viewDialogVisible = false;
      this.auditDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.stationIdChecked = [];
      this.stationCheckAll = false;
      this.oilCodesCheckAll = false;
      this.oilCodesChecked = [];
      this.payChannelCheckAll = false;
      this.payChannelChecked = [];
      this.svcGroupCheckAll = false;
      this.svcGroupChecked = [];
      this.userGroupCheckAll = false;
      this.userGroupChecked = [];
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'update':
          that.handleUpdate();
          break;

        case 'audit':
          that.handleAudit();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this7;
                that.$refs['formData'].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    createActivity(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this8;
                console.log(that.formdata);
                that.$refs['formData'].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    var param = that.getParam();
                    param.auditStatus = 1;
                    param.activityStatus = 2;
                    updateActivity(param).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    //公共校验函数
    validFormData: function validFormData() {
      var that = this;
      var valid = true;

      if (that.stationIdChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动油站'
        });
        return false;
      }

      if (that.oilCodesChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动油品'
        });
        return false;
      }

      if (that.payChannelChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择支付方式'
        });
        return false;
      }

      if (that.payChannelChecked.includes(1002) && that.svcGroupChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择大客户群'
        });
        return false;
      }

      if (that.payChannelChecked.filter(function (item) {
        return item != 1002;
      }).length > 0 && that.userGroupChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择会员群'
        });
        return false;
      }

      that.formData.giveTicketList.forEach(function (item) {
        if (isNaN(item.limitMoney) || parseFloat(item.limitMoney) < 0) {
          valid = false;
        }

        item.tickets.forEach(function (item2) {
          if (!item2.ticketRuleNo || !item2.ticketRuleNo.trim() || item2.num == '' || item2.num < 1) {
            valid = false;
          }
        });
      });

      if (!valid) {
        that.$message({
          type: 'warning',
          message: '请完善赠送优惠券信息'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      debugger;
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      var param = {
        activityNo: formData.activityNo,
        activityName: formData.activityName,
        activitySellerType: this.discountLevel,
        activityType: this.activityType,
        activityStatus: formData.activityStatus,
        dateStart: this.dateRangeValueArr[0],
        dateEnd: this.dateRangeValueArr[1],
        activityMainRule: {
          isNewRegister: 2,
          isNewPay: 2,
          isNeedShare: 2,
          isLimitGoods: 1,
          isLimitSeller: 1,
          isLimitPayChannel: 1,
          isShowDialog: 1,
          isRepeat: this.formData.isRepeat,
          perdayLimit: this.formData.perdayLimit,
          isLimitUserGroup: this.payChannelChecked.filter(function (item) {
            return item != 1002;
          }).length > 0 ? 1 : 2,
          isLimitSvcGroup: this.payChannelChecked.indexOf(1002) > -1 ? 1 : 2
        },
        activityGoodsList: [],
        activityMainSellerList: [],
        activityPayChannelList: [],
        activitySvcGroupList: [],
        activityUserGroupList: [],
        activitySubPaysuccess: {
          activityPaysuccessNo: formData.activityPaysuccessNo,
          limitMoneyType: formData.limitMoneyType
        },
        activitySubPaysuccessTicket: []
      };
      that.oilCodesChecked.forEach(function (item) {
        param.activityGoodsList.push({
          'goodsSpu': item + '',
          'sellerGoodsType': 1
        });
      });
      that.stationIdChecked.forEach(function (item) {
        param.activityMainSellerList.push({
          'sellerId': parseInt(item)
        });
      });
      that.payChannelChecked.forEach(function (item) {
        param.activityPayChannelList.push({
          'payChannel': parseInt(item)
        });
      });
      that.svcGroupChecked.forEach(function (item) {
        param.activitySvcGroupList.push({
          'svcGroupId': parseInt(item)
        });
      });
      that.userGroupChecked.forEach(function (item) {
        param.activityUserGroupList.push({
          'userGroupId': parseInt(item)
        });
      });
      that.formData.giveTicketList.forEach(function (item) {
        debugger;
        param.activitySubPaysuccessTicket.push({
          'limitMoney': parseFloat(item.limitMoney),
          'paysuccessTicket': JSON.stringify(item.tickets)
        });
      });
      return param;
    }
  }
};